import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner, Stack, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import ".././../assets/css/ListComponentsTable.css"
import { ROUTES } from "../../constants/webRouting";
import InfoPill from "../InfoPill";
import { getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";

const ContactList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const [body, setBody] = useState();
  useEffect(() => {
    async function init() {
      const result = await fuziElevatorsApi.fetchContacts();

      if (result) {
        setBody(result);
      } else {
        setBody([]);
      }
    }
    init();
  }, []);

  // Create table headers consisting of 4 columns.
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.

  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Name",
        prop: "contact_name",
        isFilterable: true,
        cell: (row) => (
          <Link to={`${ROUTES.CONTACT.LIST}/${row.id}`} state={row}>
            {row.contact_name}
          </Link>
        ),
        isSortable: true,
      },
      { title: "Complete Address", prop: "street" ,isFilterable: true, isSortable: false },
      { title: "City", prop: "city", isFilterable: true },
      { title: "Email", prop: "email", isFilterable: true },
      { title: "Mobile Number", prop: "phone", isFilterable: true },
      { title: "Contact Type", prop: "title", isFilterable: true, isSortable: false }
    );
  } else {
    //for mobile device
    header.push({
      title: "Info",
      prop: "name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.CONTACT.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.firstname} {row.lastname}
          </Link>

          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.email}
          </span>
        </div>
      ),
    });
  }


  const labels = {
    beforeSelect: " ",
  };

  const createContact = () => {
    navigate(ROUTES.CONTACT.CREATE);
  };

  const customFilter = (rows, filters) => {
    return rows.filter((row) => {
      return Object.keys(filters).every((column) => {
        const filterValue = filters[column]?.toLowerCase() || "";
        if (!filterValue) return true; // filter empty hai to row include karo

        const rowValue = row[column]?.toString().toLowerCase() || "";
        return rowValue.includes(filterValue); // substring + case-insensitive
      });
    });
  };



  return (
    <Container fluid>
      <DatatableWrapper
        body={(body && Array.isArray(body)) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
        filterFunction={customFilter}
      >
        <Row className="align-items-end ">
          <Col>
            <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
          </Col>
          <Col
            md={1}
          >
            <PaginationOptions labels={labels} />
          </Col>

          <Col className="py-1">
            <BrowserView>
              <div className="d-flex py-1 px-2 ">
                <InfoPill left="Total" right={body?.length} rightClasses="bg-custom text-white border-white fw-bold" leftClasses="bg-white text-danger fw-bold " />
              </div>
            </BrowserView>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_CONTACT].some(permission => {
                return userInfo?.permissions.map(p => p.name).includes(permission);
              }) &&
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => createContact(true)}
                >
                  New Contact
                </Button>
              }
            </Stack>
          </Col>
        </Row>

        <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
        </div>
        {/* <div className="table-scroll">
  <Table striped className="shadow rounded sm my-4">
    <TableHeader classes={{ th: "sticky-header" }} />
    {
      (body && Array.isArray(body)) ?
        <TableBody />
        :
        <tbody>
          <tr>
            <td colSpan={100} align="center">
              <Spinner />
            </td>
          </tr>
        </tbody>
    }
  </Table>
</div> */}

        <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
      </DatatableWrapper>
    </Container>
  );
};

export default ContactList;
